import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppInsightsService } from '../app-insights.service';
import {
  ICustomerListFilter, ICustomerList, ICustomerKpiDetails, IDashboardDetails, ICustomerInfoDetails, IFacilityCustomerRentalUnitInfoModels, ISaveModel,
  IGetCustomerUnitNotes, IFacilityCustomerRentalMarketingInfoModel, IcustomerUnitUnlock, ICustomerRentalStatusList, ICustomerModiftRentalInfo,
  ICustomerRentRaiseDetails, ICustomerRentRaiseSetttings, ILeaseLien, ICustomerAppliedFees, ICustomerManualFees, ICustomerDiscounts, ICustomerMoveInSettings,
  ICustomerPropertyProtection, ITransferCreditUnitDetails, IVacateReasons, ICustomerDues, ICustomerPrepayCount, ICustomerPrePeriodDues, ISaveMoveout, ILedgerDetails, ICustomerDocuments,
  ITransacrionList, IMoveOutReinstate, IManualUnits, ILeaseRestrictions, ICustomerCasesListModel, ICustomerCasesFilterModel, ICustomerCasesModel, ILatestLeaseResponse,
  ICustomerDocumentStatus, IAutoPayInfo
} from 'src/app/Shared/models/CustomerModel';
import { ISaveCloseStoreResponse, ISaveDeleteResponse } from 'src/app/Shared/interface';
import { IMoveOutResponse } from 'src/app/Shared/interface2';
import { EPaymentOrigin } from 'src/app/Shared/enum';
import { FingerPrintService } from '../fingerPrint/fingerprint.service';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private baseURL = this.appService.config.apiBaseUrl;
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient,
    private appinsights: AppInsightsService,
    public fingerPrintService: FingerPrintService,
    private appService: AppService) { }

  SaveTenantAttachment(attchementDoc): Observable<any> {
    const url = `${this.baseURL}/CustomerDocuments/SaveTenantAttachment`;
    return this.http.post<ICustomerList>(url, attchementDoc, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetDocumentTypes(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/CustomerDocuments/GetDocumentTypes`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const docType = res.body as any;
          return docType;
        }),
        catchError(this.handleError)
      );
  }

  GetTenantAttachmentDocuments(tenantId, facId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/CustomerDocuments/GetTenantAttachmentDocuments?tenantId=${tenantId}&facilityId=${facId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const atdoc = res.body as any;
          return atdoc;
        }),
        catchError(this.handleError)
      );
  }

  DeleteAttachment(attachmentId: number) {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(`${this.baseURL}/CustomerDocuments/DeleteAttachments?DocumentId=${attachmentId}`, options);
  }

  GetFacilityCustomers(customerListFilter: ICustomerListFilter): Observable<ICustomerList> {
    const url = `${this.baseURL}/Customer/GetFacilityCustomers`;
    return this.http.post<ICustomerList>(url, customerListFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetAutoPayDetails(leaseNo: number, facilityId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ModifyRentals/GetAutoPayDetails?leaseNo=${leaseNo}&facilityId=${facilityId}`,
      { observe: 'response' }).pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerKpiDetails(facilityID: number): Observable<ICustomerKpiDetails> {
    return this.http.get<ICustomerKpiDetails>(
      `${this.baseURL}/Customer/GetCustomerKpiDetails?facilityID=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as ICustomerKpiDetails;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  GetDashboardDetails(facilityID: number, leaseNo: number, tenantId: number): Observable<IDashboardDetails> {
    return this.http.get<IDashboardDetails>(
      `${this.baseURL}/Customer/GetDashboardDetails?facilityID=${facilityID}&leaseNo=${leaseNo}&TenantId=${tenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as IDashboardDetails;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerInfoDetails(tenantId: number): Observable<ICustomerInfoDetails> {
    return this.http.get<ICustomerInfoDetails>(
      `${this.baseURL}/Customer/GetCustomerDetails?tenantId=${tenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const infodata = res.body as ICustomerInfoDetails;
          return infodata;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerCaseslist(Customercaselist: ICustomerCasesFilterModel): Observable<ICustomerCasesListModel> {
    const url = `${this.baseURL}/Customer/GetCustomerCasesList`;
    return this.http.post<ICustomerCasesListModel>(url, Customercaselist, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  savecustomercases(caseobj: ICustomerCasesModel): Observable<ISaveModel> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/Customer/SaveCustomerCases`;

    return this.http.post<ISaveModel>(url, caseobj, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  Getcustomercasedetails(casesId: number): Observable<ICustomerCasesModel> {
    return this.http.get<ICustomerCasesModel>(
      `${this.baseURL}/Customer/GetCustomerCasesDetails?casesId=${casesId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as ICustomerCasesModel;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  updateCustomerInfo(customerInfo: ICustomerInfoDetails): Observable<ISaveDeleteResponse> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    let url = `${this.baseURL}/Customer/UpdateCustomerInfo`;

    return this.http.post<ISaveDeleteResponse>(url, customerInfo, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerRentalUnitsInfoDetails(facilityID: number, tenantId: number): Observable<ICustomerRentalStatusList[]> {
    return this.http.get<ICustomerRentalStatusList[]>(
      `${this.baseURL}/Customer/GetCustomerRentalUnitsInfoDetails?facilityID=${facilityID}&tenantId=${tenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as ICustomerRentalStatusList[];
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerRentalDetails(tenantId: number, leaseNo: number, facilityID: number): Observable<IFacilityCustomerRentalUnitInfoModels> {
    return this.http.get<IFacilityCustomerRentalUnitInfoModels>(
      `${this.baseURL}/Customer/GetCustomerRentalDetails?TenantId=${tenantId}&leaseNo=${leaseNo}&facilityID=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as IFacilityCustomerRentalUnitInfoModels;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getRefundDetails(leaseNo, facId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Customer/GetRefundDetails?leaseNo=${leaseNo}&facilityId=${facId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const data = res.body as any;
          return data;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerUnitNotes(details): Observable<ISaveModel> {
    var url = `${this.baseURL}/Customer/SaveCustomerUnitNotes`;
    return this.http.post<ISaveModel>(url, details, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  UpdateLeaseStatus(customerUnitUnlockObj: IcustomerUnitUnlock): Observable<ISaveModel> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    const url = `${this.baseURL}/Customer/UpdateGateStatus`;
    return this.http.post<ISaveModel>(url, customerUnitUnlockObj, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerUnitNotes(noteObj): Observable<IGetCustomerUnitNotes[]> {
    const url = `${this.baseURL}/Customer/GetCustomerUnitNotes`;
    return this.http.post<IGetCustomerUnitNotes[]>(url, noteObj, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }

  GetMarketingInfoDetails(facilityID: number, leaseNo: number): Observable<IFacilityCustomerRentalMarketingInfoModel[]> {
    return this.http.get<IFacilityCustomerRentalMarketingInfoModel[]>(
      `${this.baseURL}/Customer/GetMarketingInfoDetails?facilityID=${facilityID}&leaseNo=${leaseNo}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as IFacilityCustomerRentalMarketingInfoModel[];
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerAlternateContacts(leaseNo: number, facilityID: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/ModifyRentals/GetAlternateContacts?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const contactList = res.body as any[];
          return contactList;
        }),
        catchError(this.handleError)
      );
  }

  getAlternateContactsByTenantId(TenantId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/ModifyRentals/GetAlternateContactsByTenantId?tenantId=${TenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const contactList = res.body as any[];
          return contactList;
        }),
        catchError(this.handleError)
      );
  }

  saveAlternateContactDetails(details): Observable<ISaveModel> {
    var url = `${this.baseURL}/ModifyRentals/SaveAlternateContacts`;
    return this.http.post<ISaveModel>(url, details, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerInvoiceSettings(leaseNo: number, facilityID: number): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/ModifyRentals/GetLeaseInvoiceSettings?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const invoiceSettings = res.body as any;
          return invoiceSettings;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerInvoiceSettings(details): Observable<ISaveModel> {
    var url = `${this.baseURL}/ModifyRentals/SaveLeaseInvoiceSettings`;
    return this.http.post<ISaveModel>(url, details, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerScheduledMoveOutSettings(leaseNo: number, facilityID: number): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/ModifyRentals/GetScheduledMoveOutDetails?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const moveOutSettings = res.body as any;
          return moveOutSettings;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerModifyRentalInfo(leaseNo: number, facilityID: number): Observable<ICustomerModiftRentalInfo> {
    return this.http.get<ICustomerModiftRentalInfo>(
      `${this.baseURL}/ModifyRentals/GetModifyRentalInfo?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const modiftRentalDetails = res.body as ICustomerModiftRentalInfo;
          return modiftRentalDetails;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerRentRaiseDetails(leaseNo: number, facilityID: number): Observable<ICustomerRentRaiseDetails[]> {
    return this.http.get<ICustomerRentRaiseDetails[]>(
      `${this.baseURL}/ModifyRentals/GetLeaseRentRaiseDetails?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const rentRaiseDetails = res.body as ICustomerRentRaiseDetails[];
          return rentRaiseDetails;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerRentRaiseSettings(facilityID: number): Observable<ICustomerRentRaiseSetttings> {
    return this.http.get<ICustomerRentRaiseSetttings>(
      `${this.baseURL}/ModifyRentals/GetFacilityRentRaiseSettings?facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const rentRaiseSettings = res.body as ICustomerRentRaiseSetttings;
          return rentRaiseSettings;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerLeaseLienStages(leaseNo, facilityID: number): Observable<ILeaseLien[]> {
    return this.http.get<ILeaseLien[]>(
      `${this.baseURL}/ModifyRentals/GetLeaseLienStages?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const leaseLienList = res.body as ILeaseLien[];
          return leaseLienList;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerFacilityPeriodSettings(facilityID: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PeriodSettings/GetFacilityPeriodSettingForWeekly?facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const periodSettings = res.body as any;
          return periodSettings;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerAppliedFeesAndCharges(leaseNo, facilityID: number): Observable<ICustomerAppliedFees[]> {
    return this.http.get<ICustomerAppliedFees[]>(
      `${this.baseURL}/ModifyRentals/GetAppliedFeesForCustomers?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const feesList = res.body as ICustomerAppliedFees[];
          return feesList;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerManualFeesAndCharges(unitId, facilityID: number): Observable<ICustomerManualFees[]> {
    return this.http.get<ICustomerManualFees[]>(
      `${this.baseURL}/ModifyRentals/GetManualFeesForCustomers?unitId=${unitId}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const menualFeesList = res.body as ICustomerManualFees[];
          return menualFeesList;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerDiscounts(leaseNo, facilityID: number, isCallcenter): Observable<ICustomerDiscounts[]> {
    return this.http.get<ICustomerDiscounts[]>(
      `${this.baseURL}/ModifyRentals/GetDiscountsForCustomers?leaseNo=${leaseNo}&facilityId=${facilityID}&CallCenter=${isCallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const discountList = res.body as ICustomerDiscounts[];
          return discountList;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerMoveInSettings(facilityID: number): Observable<ICustomerMoveInSettings> {
    return this.http.get<ICustomerMoveInSettings>(
      `${this.baseURL}/Prospects/GetFacilityMoveInSettings?facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const MoveInSettings = res.body as ICustomerMoveInSettings;
          return MoveInSettings;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerPropertyProtection(leaseNo, facilityID): Observable<ICustomerPropertyProtection[]> {
    return this.http.get<ICustomerPropertyProtection[]>(
      `${this.baseURL}/ModifyRentals/GetRentalPropertyProtectionSchemes?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const propertyProtction = res.body as ICustomerPropertyProtection[];
          return propertyProtction;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerPeriodSettings(facilityID: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PeriodSettings/GetFacilityPeriodSettingForWeekly?facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const periodSettings = res.body as any;
          return periodSettings;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerLeaseLien(details): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/ModifyRentals/SaveLeaseLienStages`;

    return this.http.post<any>(url, details, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerModifiedRentals(details): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/ModifyRentals/SaveModifiedRentalDetails`;

    return this.http.post<any>(url, details, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerRentRaiseDetails(details): Observable<ISaveModel> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/ModifyRentals/SaveLeaseRentRaiseDetails`;

    return this.http.post<ISaveModel>(url, details, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getMoveOutSettings(facilityId): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/Prospects/GetFacilityMoveOutSettings?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetTenantsRentedUnits(tenantId, facilityId, donotListMovedOutUnit: boolean): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/Customer/GetTenantsRentedUnits?tenantId=${tenantId}&facilityId=${facilityId}&donotListMovedOutUnit=${donotListMovedOutUnit}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetLinkedUnitsForTransferCredits(tenantId, facilityId): Observable<ITransferCreditUnitDetails[]> {
    return this.http.get<ITransferCreditUnitDetails[]>(
      `${this.baseURL}/MoveOut/GetLinkedUnitsForTransferCredits?tenantId=${tenantId}&facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as ITransferCreditUnitDetails[];
        }),
        catchError(this.handleError)
      );
  }

  GetDues(leaseNo, facilityId): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/MoveOut/GetDues?leaseNo=${leaseNo}&facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetTransferSetting(facilityId): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/MoveOut/GetFacilityTransferSettings?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getVacateReasons(): Observable<IVacateReasons[]> {
    return this.http.get<IVacateReasons[]>(
      `${this.baseURL}/MoveOut/GetVacateReasons`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const Reasons = res.body as IVacateReasons[];
          return Reasons;
        }),
        catchError(this.handleError)
      );
  }

  GetMoveOutTenantLedger(inputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/MoveOut/GetMoveOutTenantLedger`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetDuesForChargeTillDate(inputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/MoveOut/GetDuesForChargeTillDate`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getMakePaymentDues(leaseNo, facilityID, isAuctionProceed, transactionType): Observable<ICustomerDues> {
    return this.http.get<ICustomerDues>(
      `${this.baseURL}/MakePayment/GetDuesForPayment?leaseNo=${leaseNo}&facilityId=${facilityID}&isAuctionProceed=${isAuctionProceed}&transactionType=${transactionType}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const dues = res.body as ICustomerDues;
          return dues;
        }),
        catchError(this.handleError)
      );
  }
  GetPrepayCount(leaseNo, facilityID): Observable<ICustomerPrepayCount> {
    return this.http.get<ICustomerPrepayCount>(
      `${this.baseURL}/Prospects/GetPrepayCount?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const dues = res.body as ICustomerPrepayCount;
          return dues;
        }),
        catchError(this.handleError)
      );
  }
  getPrePaymentCharges(obj): Observable<ICustomerPrePeriodDues[]> {
    return this.http.post<ICustomerPrePeriodDues[]>(
      `${this.baseURL}/MakePayment/GetChargesForPrePayment`,
      obj,
      { observe: 'response' })
      .pipe(
        map(res => {
          const dues = res.body as ICustomerPrePeriodDues[];
          return dues;
        }),
        catchError(this.handleError)
      );
  }

  getTenantLedgerDetails(facId, leaseNo): Observable<ILedgerDetails> {
    return this.http.get<ILedgerDetails>(
      `${this.baseURL}/Prospects/GetTenantLedgers?facilityId=${facId}&leaseNumber=${leaseNo}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const ledgerDetails = res.body as ILedgerDetails;
          return ledgerDetails;
        }),
        catchError(this.handleError)
      );
  }

  saveMoveout(moveoutInput: ISaveMoveout): Observable<IMoveOutResponse> {
    let options = {};
    if ((this.fingerPrintService.paymentOrigin == EPaymentOrigin.MoveOut || this.fingerPrintService.paymentOrigin == EPaymentOrigin.MakePayment)
      && this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    const url = `${this.baseURL}/MoveOut/SaveMoveOut`;
    return this.http.post<IMoveOutResponse>(url, moveoutInput, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  saveTransfer(transInput): Observable<any> {
    let options = {};
    if (this.fingerPrintService.paymentOrigin == EPaymentOrigin.Transfer
      && this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    const url = `${this.baseURL}/Transfer/SaveTransfer`;
    return this.http.post<any>(url, transInput, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  saveCustomerMakePayments(details): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed && (this.fingerPrintService.paymentOrigin == EPaymentOrigin.Merchandise || this.fingerPrintService.paymentOrigin == EPaymentOrigin.MakePayment)) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/MakePayment/SavePaymentDetails`;

    return this.http.post<any>(url, details, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getPaymentInfo(ledgerId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PaymentReversal/GetPaymentInfoForLedger?ledgerId=${ledgerId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const pagedResult = res.body as any;
          return pagedResult;
        }),
        catchError(this.handleError)
      );
  }

  getRentedUnits(facId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PaymentReversal/GetRentedFacilityUnits?facilityId=${facId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const pagedResult = res.body as any;
          return pagedResult;
        }),
        catchError(this.handleError)
      );
  }

  getPostedLienLetters(facId, transDate, leaseNo): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PaymentReversal/GetPostedLienLetters?facilityId=${facId}&transactionDateTime=${transDate}&leaseNumber=${leaseNo}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const pagedResult = res.body as any;
          return pagedResult;
        }),
        catchError(this.handleError)
      );
  }

  getTenantDocuments(tenantId): Observable<ICustomerDocuments[]> {
    return this.http.get<ICustomerDocuments[]>(
      `${this.baseURL}/CustomerDocuments/GetTenantDocuments?tenantId=${tenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const documents = res.body as any;
          return documents;
        }),
        catchError(this.handleError)
      );
  }

  GetDocumentStatus(facilityId, adsQueueId, documentId): Observable<ICustomerDocumentStatus> {
    return this.http.get<ICustomerDocumentStatus>(
      `${this.baseURL}/CustomerDocuments/GetDocumentStatus?facilityId=${facilityId}&adsQueueId=${adsQueueId}&documentId=${documentId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const documents = res.body as ICustomerDocumentStatus;
          return documents;
        }),
        catchError(this.handleError)
      );
  }

  UploadDocumentToMailHouse(documentId, facilityId, documentTypeIdentifier,retryButton): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
    let url = `${this.baseURL}/CustomerDocuments/UploadDocumentToMailHouse?documentId=${documentId}&facilityId=${facilityId}&documentTypeIdentifier=${documentTypeIdentifier}&retryButton=${retryButton}`;

    return this.http.post<any>(url, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerTransactionList(tenantId): Observable<ITransacrionList[]> {
    return this.http.get<ITransacrionList[]>(`${this.baseURL}/Customer/GetAllTransactionList?tenantId=${tenantId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const transactionList = res.body as ITransacrionList[];
          return transactionList;
        }), catchError(this.handleError)
      );
  }

  GetUnitInfoForManualInvoice(tenantId, leaseNo, facilityId): Observable<IManualUnits> {
    return this.http.get<IManualUnits>(`${this.baseURL}/ManualInvoice/GetUnitInfoForManualInvoice?tenantId=${tenantId}&leaseNo=${leaseNo}&facilityId=${facilityId}`, { observe: 'response' })
      .pipe(map(res => {
        const UnitInfoForManualInvoice = res.body as IManualUnits;
        return UnitInfoForManualInvoice;
      }), catchError(this.handleError));
  }

  getInvoiceSettings(facilityID: number): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/ManualInvoice/GetFacilityInvoiceSettings?facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const invoiceSettings = res.body as any;
          return invoiceSettings;
        }),
        catchError(this.handleError)
      );
  }

  GenerateManualInvoice(inputModel): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    const url = `${this.baseURL}/ManualInvoice/GenerateManualInvoice`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  UpdateInvoiceBlobReference(receiptNumber, receiptURL): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
    let url = `${this.baseURL}/ManualInvoice/UpdateInvoiceBlobReference?receiptNumber=${receiptNumber}&receiptURL=${receiptURL}`;

    return this.http.post<any>(url, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getCustomerTransactionMoveOutDetails(leaseNo, facilityId): Observable<IMoveOutReinstate> {
    return this.http.get<IMoveOutReinstate>(`${this.baseURL}/Customer/GetMoveOutDetails?leaseNo=${leaseNo}&facilityId=${facilityId}`, { observe: 'response' })
      .pipe(map(res => {
        const moveOutDetails = res.body as IMoveOutReinstate;
        return moveOutDetails;
      }), catchError(this.handleError));
  }

  savePaymentReversal(requestParams): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/PaymentReversal/SavePaymentReversal`;

    return this.http.post<any>(url, requestParams, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  saveRefund(requestParams): Observable<any> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    var url = `${this.baseURL}/Refund/SaveRefund`;

    return this.http.post<any>(url, requestParams, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  SaveAllowanceReversal(model): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let url = `${this.baseURL}/PaymentReversal/SaveAllowanceReversal`;

    return this.http.post<any>(url, model, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetLeaseRestrictions(leaseNo: number, facilityId: number): Observable<ILeaseRestrictions> {
    return this.http.get<ILeaseRestrictions>(
      `${this.baseURL}/ModifyRentals/GetLeaseRestrictions?leaseNo=${leaseNo}&facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const restrictions = res.body as ILeaseRestrictions;
          return restrictions;
        }),
        catchError(this.handleError)
      );
  }

  SaveLeaseRestrictions(details: ILeaseRestrictions): Observable<ISaveModel> {
    let options = {};
    if (this.fingerPrintService.isFingerPrintUsed) {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
    } else {
      options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    }
    const url = `${this.baseURL}/ModifyRentals/SaveLeaseRestrictions`;
    return this.http.post<ISaveModel>(url, details, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  SavePartialPaymentReturn(leaseNo, facilityId, amount, note): Observable<ISaveModel> {
    const url = `${this.baseURL}/MakePayment/SavePartialPaymentReturn?leaseNo=${leaseNo}&facilityId=${facilityId}&amount=${amount}&note=${note}`;
    return this.http.post<ISaveModel>(url, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }

  GetLastPaymentMode(leaseNo: number, facilityID: number, transactionTypeId: number): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/Refund/GetLastPaymentMode?leaseNumber=${leaseNo}&facilityId=${facilityID}&transactionTypeId=${transactionTypeId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const response = res.body as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getLedgerDetailsforReservation(facId, reservationNo): Observable<ILedgerDetails> {
    return this.http.get<ILedgerDetails>(
      `${this.baseURL}/Prospects/GetLedgerDetailsforReservation?facilityId=${facId}&leaseNumber=${reservationNo}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const ledgerDetails = res.body as ILedgerDetails;
          return ledgerDetails;
        }),
        catchError(this.handleError)
      );
  }

  getLeaseUrl(facId: number, leaseNo: number): Observable<ILatestLeaseResponse> {
    return this.http.get<ILatestLeaseResponse>(
      `${this.baseURL}/CustomerDocuments/GetTenantLeaseLetterURL?facilityId=${facId}&leaseNo=${leaseNo}`,
      { observe: 'response' }).pipe(
        map(res => {
          return res.body as ILatestLeaseResponse;
        }),
        catchError(this.handleError)
      );
  }

  getTenantAutopayUnitsList(tenantId: number, facId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Customer/GetTenantAutopayUnitsList?tenantId=${tenantId}&facilityId=${facId}`,
      { observe: 'response' }).pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  SaveLeaseRegenerationReason(notesList: any): Observable<ISaveCloseStoreResponse> {
    let options = {};
    options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let url = '';
    url = `${this.baseURL}/Customer/SaveLeaseRegenerationReason`;

    return this.http.post<ISaveCloseStoreResponse>(url, notesList, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }
  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

  getGateStatus(leaseNo: number, facilityID: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/customer/GetGateStatus?facilityId=${facilityID}&leaseNo=${leaseNo}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const gateLockDetails = res.body;
          return gateLockDetails;
        }),
        catchError(this.handleError)
      );
  }

  GetRentalTiedWithInquiryORReservation(leaseNo: number, facilityID: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/customer/GetRentalTiedWithInquiryORReservation?leaseNo=${leaseNo}&facilityId=${facilityID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const response = res.body;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetProspectsListForTieRentalSearch(inputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/customer/GetProspectsListForTieRentalSearch`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  UnLinkInquiryOrReservationWithRental(inputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/customer/UnLinkInquiryOrReservationWithRental`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  LinkInquiryOrReservationWithRental(inputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/customer/LinkInquiryOrReservationWithRental`;
    return this.http.post<any>(url, inputModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  UpdateAuctionDateTime(details): Observable<ISaveModel> {
    var url = `${this.baseURL}/Customer/UpdateAuctionDateTime`;
    return this.http.post<ISaveModel>(url, details, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetCustomerMakePaymentDetails(details): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/MakePayment/GetCustomerMakePaymentStatus`, details, { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetAutoPayHistoryDetails(tenantId, facilityId): Observable<IAutoPayInfo[]> {
    return this.http.get<IAutoPayInfo[]>(`${this.baseURL}/ModifyRentals/GetAutoPayHistoryDetails?tenantId=${tenantId}&facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const autopayHistoryList = res.body as IAutoPayInfo[];
          return autopayHistoryList;
        }), catchError(this.handleError)
      );
  }

  ConvertAutopayHistoryToPDF(autopayHistory: any) {
    let urlVal = `${this.baseURL}/SWT/ConvertAutoPayHistoryDetailsToPDF`;
    return this.http.post(urlVal, autopayHistory, { responseType: 'blob' })
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  DeletePaymentSetUp(details) {
    let url = `${this.baseURL}/ModifyRentals/DeletePaymentSetUp`;
    return this.http.post<any>(url, details, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  UpdateTenantLettersandNotices(documentId, documentTypeIdentifier) : Observable<any> {
    let url = `${this.baseURL}/CustomerDocuments/UpdateTenantLettersandNotices?documentId=${documentId}&documentTypeIdentifier=${documentTypeIdentifier}`;
    return this.http.post<any>(url, documentId, this.options)
    .pipe(
      map(res => {
        return res;
      }),
      catchError(this.handleError)
    );
  }
  CustmoerNotesDetails: EventEmitter<any> = new EventEmitter();

}
